// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"8e4a38ba","213":"67e6f08a","453":"d9edb766","541":"a76d3b88","634":"53e5a41c","854":"c9596a68"}[chunkId] + ".chunk.js";
};